module.exports = __webpack_public_path__ + "img/cartoesP2.03acd106.png";